import { useTranslation } from "react-i18next";
import VisibilityToggle from "../VisibilityToggle/VisibilityToggle";

function Loader({ visible }: any) {
  const {t} = useTranslation();
  return (
    <VisibilityToggle visible={visible}>
      <div id="loader" className="center">
        <div className="text-center">
          <img src="/assets/images/loader-green.gif" width="50" alt="Loading" />
          <p >{t('Loading')}</p>
        </div >
      </div >
    </VisibilityToggle>
  )
}

export default Loader;